import React from 'react';


export default class TextField extends React.Component {
  render() {
    let {
      type,
      onChange,
      onBlur,
      value,
      errorText,
      floatingLabelText,
      hintText,
      fullWidth,
      multiLine,
      errorStyle,
      ...rest
    } = this.props;

    value = value || '';

    return <input type={type ? type : "text"} readOnly={this.props.readonly ? this.props.readonly : false} placeholder={hintText} className="ready-text-input" onChange={onChange} onBlur={onBlur} value={value} {...rest} />
  }
}



// WEBPACK FOOTER //
// ./src/components/TextField.js